import { render, staticRenderFns } from "./ChapterMarkAndFinish.vue?vue&type=template&id=c04810a2&scoped=true&"
import script from "./ChapterMarkAndFinish.vue?vue&type=script&lang=js&"
export * from "./ChapterMarkAndFinish.vue?vue&type=script&lang=js&"
import style0 from "./ChapterMarkAndFinish.vue?vue&type=style&index=0&id=c04810a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04810a2",
  null
  
)

export default component.exports